import { Sparkles, Globe2, ShieldCheck } from "lucide-react";

const values = [
  {
    icon: Sparkles,
    title: "Intuitive Design",
    caption: "No steep learning curve—start editing in minutes."
  },
  {
    icon: Globe2,
    title: "Works Everywhere",
    caption: "Edit on any device—no installs required."
  },
  {
    icon: ShieldCheck,
    title: "Secure & Private",
    caption: "Your videos are encrypted and never shared."
  }
];

const WhyChooseUs = () => (
  <section className="mx-auto max-w-4xl px-4 py-12">
    <h2 className="text-xl md:text-3xl font-bold text-center mb-8">Why Choose Our Editor?</h2>
    <div className="flex flex-col md:flex-row justify-center gap-8">
      {values.map(({ icon: Icon, title, caption }) => (
        <div key={title} className="flex-1 flex flex-col items-center px-4 py-6 bg-accent rounded-xl shadow-md">
          <Icon className="w-8 h-8 text-blue-500 mb-2" />
          <div className="text-lg font-semibold mb-1 text-foreground">{title}</div>
          <div className="text-sm text-muted-foreground text-center">{caption}</div>
        </div>
      ))}
    </div>
  </section>
);

export default WhyChooseUs;
